import { useQuery } from '@tanstack/react-query';
import { GameService } from '../services';
import { queryKeys } from './query-keys';
function useGameQuery(gameId, query) {
  return useQuery({
    queryKey: queryKeys.game.all(gameId),
    queryFn: () => GameService.getGame(gameId, {
      query
    }),
    enabled: gameId !== undefined,
    staleTime: Infinity
  });
}
export default useGameQuery;